/**
 * @param {object} query - объект с query-параметрами ({ "utm_source": "default" })
 * @returns {string} - строка с query-параметрами (пример - "utm_source=default&utm_campaign=default")
 * @description Преобразовывает объект с query-параметрами в строку, пригодную для прокидывания в конец ссылки.
 */
const generateQueryString = (query = {}) => {
  const utmParams = new URLSearchParams(query);
  return utmParams.toString();
};

/**
 * @param {string} link - ссылка
 * @param {string} utmString - строка с utm-параметрами utm_source=default&utm_campaign=test
 * @returns {string} - ссылка с query-параметрами (пример - "/link?utm_source=default&utm_campaign=default")
 * @description Добавляет к ссылке переданные query-параметры
 */
const appendQueryToLink = (link, utmString) => {
  if (!utmString) return link;
  return link?.includes("?") ? `${link}&${utmString}` : `${link}?${utmString}`;
};

module.exports = {
  appendQueryToLink,
  generateQueryString,
};
